export default "__VITE_ASSET__D9uePaf6__"